if (!customElements.get('product-shortlist')) {
  customElements.define('product-shortlist', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.querySelectorAll('[data-list]').forEach(button => button.addEventListener('click', () => this.openList(button.dataset.list)));
    }
    read(kind) {
      try {
        const value = JSON.parse(localStorage.getItem(`bn-products-${kind}`) || '[]');
        return Array.isArray(value) ? value.filter(p => p && typeof p.url === 'string' && /^\/products\/[a-zA-Z0-9%_-]+$/.test(p.url) && typeof p.title === 'string').slice(0, 20) : [];
      } catch { return []; }
    }
    write(kind, items) {
      try { localStorage.setItem(`bn-products-${kind}`, JSON.stringify(items)); }
      catch { this.querySelector('[role="status"]').textContent = 'Browser storage is unavailable. This list is available for this view only.'; }
    }
    openList(kind) {
      const facts = [...this.closest('product-info').querySelectorAll('.bn-product-summary > div')].map(e => [e.querySelector('dt')?.textContent, e.querySelector('dd')?.textContent]);
      const current = { title: this.dataset.title, url: this.dataset.url, brand: this.dataset.brand, facts };
      const items = this.read(kind);
      const existing = items.findIndex(p => p.url === current.url);
      if (existing >= 0) items[existing] = current;
      else if (items.length < (kind === 'compare' ? 4 : 20)) items.push(current);
      else this.querySelector('[role="status"]').textContent = 'Your list is full. Remove a product to make room.';
      this.write(kind, items);
      this.render(kind, items);
      this.dialog.showModal();
    }
    render(kind, items) {
      this.dialog.querySelector('h2').textContent = kind === 'compare' ? 'Compare products' : 'Saved products';
      const holder = this.querySelector('[data-items]');
      holder.replaceChildren();
      if (!items.length) { holder.textContent = 'Your list is empty.'; return; }
      items.forEach(item => {
        const card = document.createElement('article');
        const link = document.createElement('a'); link.href = item.url; link.textContent = item.title; card.append(link);
        const brand = document.createElement('p'); brand.textContent = item.brand || ''; card.append(brand);
        if (kind === 'compare') {
          const dl = document.createElement('dl');
          const facts = Array.isArray(item.facts) ? item.facts : [];
          facts.forEach(fact => { if (!Array.isArray(fact)) return; const dt = document.createElement('dt'); const dd = document.createElement('dd'); dt.textContent = String(fact[0] || ''); dd.textContent = String(fact[1] || ''); dl.append(dt, dd); });
          if (!facts.length) dl.textContent = 'No key specifications listed. Open the product for its full overview.';
          card.append(dl);
        }
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove';
        remove.addEventListener('click', () => { const next = items.filter(p => p.url !== item.url); this.write(kind, next); this.render(kind, next); this.querySelector('[data-items] button, [data-close]').focus(); });
        card.append(remove); holder.append(card);
      });
    }
  });
}
